import React from 'react';
import './styles.css';
import EndCallButton from './EndCallButton';
import ToggleAudioButton from './Toggles/ToggleAudioButton';
import ToggleVideoButton from './Toggles/ToggleVideoButton';
import ToggleScreenShareButton from './Toggles/ToggleScreenShareButton';
import FlipCameraButton from './Toggles/FlipCameraButton';
import useRoomState from '../../hooks/useRoomState';
import { White } from '../../utils/colors';
import useVideoContext from "../../hooks/useVideoContext";
export default function Controls(_ref) {
  var _ref$showControls = _ref.showControls,
      showControls = _ref$showControls === void 0 ? false : _ref$showControls;

  var _useVideoContext = useVideoContext(),
      themeOptions = _useVideoContext.themeOptions;

  var roomState = useRoomState();
  var isReconnecting = roomState === 'reconnecting';
  return /*#__PURE__*/React.createElement("div", {
    className: "controls-container " + (showControls ? 'show-controls' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "controls",
    style: {
      borderRadius: themeOptions.userDefined.ctrlBarRadius,
      backgroundColor: White
    }
  }, /*#__PURE__*/React.createElement(FlipCameraButton, null), /*#__PURE__*/React.createElement(ToggleAudioButton, {
    disabled: isReconnecting
  }), /*#__PURE__*/React.createElement(ToggleVideoButton, {
    disabled: isReconnecting
  }), roomState !== 'disconnected' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToggleScreenShareButton, {
    disabled: isReconnecting
  }), /*#__PURE__*/React.createElement(EndCallButton, null))));
}